import { NatGenDesignSystem } from '../../natgen-design-system';
import { flagStyles } from './flag.styles';
import { attr, FASTElement, html } from '@microsoft/fast-element';

/**
 * @element natgen-flag
 */
export class NatGenFlag extends FASTElement {
    @attr({ attribute: 'country-code' })
    public countryCode: string;
}

export const natgenFlagDefinition = NatGenFlag.compose({
    name: `${NatGenDesignSystem.prefix}-flag`,
    template: html``,
    styles: flagStyles
});
